import { createFileRoute } from "@tanstack/react-router";
import {
	drawerFormSearch,
	redirectLegacyEntityTypeForm,
} from "@/features/form-editor/lib/redirect-legacy-entity-type-form";

const ROUTE_ID =
	"/_authenticated/(admin-app)/_admin/admin/configuration/jobTypes/$jobTypeId/form" as const;

export const Route = createFileRoute(ROUTE_ID)({
	beforeLoad: ({ location, params, search }) => {
		redirectLegacyEntityTypeForm({
			pathname: location.pathname,
			typeId: params.jobTypeId,
			to: "/admin/configuration/jobTypes/$jobTypeId/schema",
			params: { jobTypeId: params.jobTypeId },
			search: drawerFormSearch(search, "full"),
		});
	},
	component: () => null,
});
